import React, { useState } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import * as yup from "yup";
import {
  AlertInfo,
  BtnGroupStyle,
  ContentStyle,
  DRxInputStyle,
  DRxSelectStyle,
  greyColor,
  InputSMBoxStyle,
  RadioGroupStyle,
  warnColor,
  IframeStyle,
  DatePickerField,
} from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import { ErrorMessage, Form, Formik } from "formik";
import DRxInput from "../../../uikit/DRxInput";
import { EPCSAuditReport, Initializer } from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import useFetch from "../../../CustomHooks/useFetch";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import { REPORT_BASE_URL } from "../../../Apis/Constants";

const initialStateEpcsAuditReport = {
  VendorName: "DIGITAL RX",
  PracticeName: "Digital Rx Test",
  SearchBy: "",
  fromDate: "",
  toDate: "",
  UserRole: "Physician",
  RadioData: "",
  ReportType: "PDF",
};

export default function PrescriberEPCSAudit() {
  const [data, setData] = useState(initialStateEpcsAuditReport);
  const prescriber = localStorage.getItem("DoctorName");
  const [value, setValue] = useState(prescriber);

  const handleChangeR = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState();
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const getGenerateEPCSAuditReport = async (values: any) => {
    try {
      const doctorId: any = localStorage.getItem("doctorId");
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("fromDate", values?.fromDate);
      params.append("toDate", values?.toDate);

      const result = await EPCSAuditReport(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setReportUrl(result?.data?.response[0]?.reportUrl);
        setPrintActive(true);
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went Wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const { data: initialData, loading }: any = useFetch({}, Initializer, []);

  const currentDate = new Date();

  return (
    <>
      <ContentStyle>
        {printActive ? (
          <Grid
            container
            item
            xs={12}
            spacing={0}
            alignItems="top"
            justifyContent="space-between"
            columnSpacing={3}
          >
            <Grid item xs={12}>
              <IframeStyle>
                <iframe src={REPORT_BASE_URL + reportUrl} title="PrintReport" />
              </IframeStyle>
            </Grid>
            <Grid item xs={12}>
              <BtnGroupStyle className="right">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    setPrintActive(false);
                  }}
                />{" "}
              </BtnGroupStyle>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography component="h6" color="primary" variant="h6">
              Prescriber EPCS Audit
            </Typography>
            {loading ? (
              <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                height={"100vh"}
              >
                <CircularProgress color="primary" />
              </Grid>
            ) : (
              <>
                <Formik
                  initialValues={data}
                  validationSchema={yup.object().shape({
                    fromDate: yup
                      .date()
                      .nullable()
                      .required("From Date is Required")
                      .typeError("Date of Birth is Required"),
                    toDate: yup
                      .date()
                      .nullable()
                      .required("To Date is Required")
                      .typeError("Date of Birth is Required"),
                  })}
                  onSubmit={(values) => {
                    setData(values);
                    getGenerateEPCSAuditReport(values);
                  }}
                >
                  {({
                    handleChange,
                    values,
                    handleBlur,
                    touched,
                    errors,
                    setFieldValue,
                  }) => (
                    <Form>
                      <Grid
                        container
                        item
                        xs={12}
                        spacing={0}
                        alignItems="top"
                        justifyContent="space-between"
                        columnSpacing={3}
                      >
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="vendorname"
                            >
                              Vendor Name
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>{" "}
                            <Box>
                              <DRxInputStyle>
                                <DRxInput
                                  id="vendorname"
                                  name="VendorName"
                                  type="text"
                                  className=""
                                  value={initialData[0]?.vendorName}
                                  disabled={true}
                                  onChange={handleChange}
                                />
                              </DRxInputStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="practicename"
                            >
                              Practice Name
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>{" "}
                            <Box>
                              <DRxInputStyle>
                                <DRxInput
                                  id="practicename"
                                  name="Practice Name"
                                  type="text"
                                  className=""
                                  disabled={true}
                                  value={initialData[0]?.practiceName}
                                  onChange={handleChange}
                                />
                              </DRxInputStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Stack
                          sx={{ width: "100%" }}
                          spacing={2}
                          marginBottom={3}
                          marginLeft={3}
                        >
                          <AlertInfo className="gray">
                            <Typography variant="body2" component={"div"}>
                              Select criteria to create a Patient Prescription
                              History and click on the{" "}
                              <Typography
                                fontWeight={600}
                                color={"primary"}
                                component={"span"}
                              >
                                "Generate Report"
                              </Typography>{" "}
                              button.
                            </Typography>{" "}
                          </AlertInfo>
                        </Stack>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="userrole"
                            >
                              User Role
                            </Typography>
                            <Box>
                              <DRxSelectStyle>
                                <DRxSelect2
                                  name="UserRole"
                                  id="userrole"
                                  options={[
                                    { value: "Physician", label: "Physician" },
                                  ]}
                                  onChange={(option: any, e: any) => {
                                    setFieldValue("UserRole", e);
                                  }}
                                  value={initialData[0]?.userRole}
                                  disabled={true}
                                />
                              </DRxSelectStyle>
                            </Box>
                          </InputSMBoxStyle>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="fromdate"
                            >
                              From Date
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>

                            <Box>
                              <DatePickerField>
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DatePicker
                                    inputFormat="MM/dd/yyyy"
                                    value={values.fromDate}
                                    maxDate={currentDate}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "fromDate",
                                        moment(e).format("MM/DD/yyyy")
                                      );
                                    }}
                                    renderInput={(params) => (
                                      <>
                                        <TextField
                                          {...params}
                                          error={
                                            touched.fromDate &&
                                            Boolean(errors.fromDate)
                                          }
                                        />
                                        <Typography
                                          color="error"
                                          className="error"
                                          variant="body2"
                                          component="div"
                                        >
                                          <ErrorMessage name="fromDate" />
                                        </Typography>
                                      </>
                                    )}
                                  />
                                </LocalizationProvider>
                              </DatePickerField>
                            </Box>
                          </InputSMBoxStyle>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="ToDate"
                            >
                              To Date
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>

                            <Box>
                              <DatePickerField>
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DatePicker
                                    inputFormat="MM/dd/yyyy"
                                    value={values.toDate}
                                    maxDate={currentDate}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "toDate",
                                        moment(e).format("MM/DD/yyyy")
                                      );
                                    }}
                                    renderInput={(params) => (
                                      <>
                                        <TextField
                                          {...params}
                                          error={
                                            touched.toDate &&
                                            Boolean(errors.toDate)
                                          }
                                        />
                                        <Typography
                                          color="error"
                                          className="error"
                                          variant="body2"
                                          component="div"
                                        >
                                          <ErrorMessage name="toDate" />
                                        </Typography>
                                      </>
                                    )}
                                  />
                                </LocalizationProvider>
                              </DatePickerField>
                            </Box>
                          </InputSMBoxStyle>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="reporttype"
                            >
                              Report Type
                            </Typography>
                            <Box>
                              <DRxSelectStyle>
                                <DRxSelect2
                                  name="ReportType"
                                  id="reporttype"
                                  options={[{ value: "PDF", label: "PDF" }]}
                                  onChange={handleChange}
                                  value={initialStateEpcsAuditReport.ReportType}
                                />
                              </DRxSelectStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="userrole"
                            ></Typography>
                            <Box>
                              <RadioGroupStyle>
                                <RadioGroup
                                  aria-labelledby="demo-controlled-radio-buttons-group"
                                  name="controlled-radio-buttons-group"
                                  value={value}
                                  onChange={handleChangeR}
                                >
                                  <FormControlLabel
                                    value={value}
                                    control={<Radio color="primary" />}
                                    label={value}
                                  />
                                </RadioGroup>
                              </RadioGroupStyle>{" "}
                              <YSButton
                                //style={{ marginTop: 3 }}
                                size="large"
                                className=""
                                color="primary"
                                dataTestId="submitBtn"
                                variant="contained"
                                disabled={false}
                                type="submit"
                                children={"Generate Reports"}
                                onClick={() => {}}
                              />
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
                <YSSnackBar
                  message={stateData.message}
                  variant={stateData.variant}
                  open={stateData.open}
                  handleClose={() => {
                    setStateData((prevState: any) => {
                      return { ...prevState, open: false };
                    });
                  }}
                />
              </>
            )}
          </>
        )}
      </ContentStyle>
    </>
  );
}
